import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { UserCheck, AlertCircle, CheckCircle2, Loader2 } from 'lucide-react';
import { API_URL } from '../../api/config';

// Página pública (sem login) aberta a partir do link enviado por e-mail ao
// master quando um cadastro novo fica pendente. Só busca os dados pra exibir
// no GET (não aprova sozinha) — a aprovação de verdade só acontece quando o
// master clica no botão, via POST — assim um scanner de e-mail que pré-carrega
// o link não aprova ninguém sem intenção humana.
function AprovarCadastro() {
  const { token } = useParams();
  const [carregando, setCarregando] = useState(true);
  const [aprovando, setAprovando] = useState(false);
  const [cadastro, setCadastro] = useState(null);
  const [erro, setErro] = useState('');
  const [aprovado, setAprovado] = useState(false);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/auth/aprovar-cadastro/${token}`)
      .then((res) => setCadastro(res.data?.data ?? res.data))
      .catch((err) =>
        setErro(err.response?.data?.error || 'Não foi possível carregar este cadastro.'),
      )
      .finally(() => setCarregando(false));
  }, [token]);

  const handleAprovar = async () => {
    setAprovando(true);
    setErro('');
    try {
      await axios.post(`${API_URL}/api/auth/aprovar-cadastro/${token}`);
      setAprovado(true);
    } catch (err) {
      setErro(err.response?.data?.error || 'Não foi possível aprovar este cadastro.');
    } finally {
      setAprovando(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-[#F9FAFB] to-[#E5E7EB] dark:from-gray-950 dark:to-gray-900 p-4">
      <div className="w-full max-w-md bg-white/80 dark:bg-gray-900/80 backdrop-blur-xl rounded-3xl border border-white/50 dark:border-gray-800/50 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.1)] p-4">
        <div className="flex flex-col items-center mb-6">
          <img src="/logo.svg" alt="Portal Novas Histórias" className="w-16 h-auto object-contain mb-4" />
          <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100 tracking-tight">
            Aprovar cadastro
          </h1>
        </div>

        {carregando ? (
          <div className="flex items-center justify-center py-8 text-gray-500 dark:text-gray-400">
            <Loader2 className="w-5 h-5 animate-spin mr-3" />
            <span className="text-sm">Carregando...</span>
          </div>
        ) : erro ? (
          <div className="flex items-start gap-2 p-3 rounded-xl bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-900/40 text-red-600 dark:text-red-400 text-sm">
            <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
            <span>{erro}</span>
          </div>
        ) : aprovado || cadastro?.jaAprovado ? (
          <div className="flex items-start gap-2 p-3 rounded-xl bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-900/40 text-green-700 dark:text-green-400 text-sm">
            <CheckCircle2 className="w-4 h-4 mt-0.5 flex-shrink-0" />
            <span>
              {aprovado
                ? 'Cadastro aprovado com sucesso.'
                : 'Este cadastro já havia sido aprovado.'}
            </span>
          </div>
        ) : (
          <>
            <div className="p-4 rounded-xl bg-gray-50 dark:bg-gray-800/60 border border-gray-100 dark:border-gray-800 mb-4">
              <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">
                Aprovar o cadastro de:
              </p>
              <p className="text-sm font-semibold text-gray-900 dark:text-gray-100" translate="no">
                {cadastro.nome}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400">{cadastro.email}</p>
              <p className="text-xs text-gray-500 dark:text-gray-400 capitalize mt-1">
                Perfil: {cadastro.perfil}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1" translate="no">
                Instituição: {cadastro.instituicao || 'Nenhuma'}
              </p>
            </div>
            <button
              onClick={handleAprovar}
              disabled={aprovando}
              className="w-full h-11 rounded-xl bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium transition-all disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {aprovando ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" /> Aprovando...
                </>
              ) : (
                <>
                  <UserCheck className="w-4 h-4" /> Aprovar cadastro
                </>
              )}
            </button>
          </>
        )}

        <div className="mt-6 text-center">
          <Link
            to="/login"
            className="text-sm text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 font-medium transition-colors"
          >
            Ir para o login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default AprovarCadastro;
